import { useState, useEffect } from "react";
import styles from "./styles.module.css";

export default function Size({ value, onChange }) {
  const [_value, setValue] = useState({
    minWidth: 40,
    maxWidth: "",
    minHeight: 40,
    maxHeight: "",
  });
  const [units, setUnits] = useState({
    minWidth: "px",
    maxWidth: "px",
    minHeight: "px",
    maxHeight: "px",
  });

  useEffect(() => {
    if (value) {
      const _value = {};
      Object.keys(value).forEach((key) => {
        _value[key] = `${value[key]}`
          .replace("px", "")
          .replace("%", "")
          .replace("vw", "")
          .replace("vh", "");
      });
      setValue(_value);
    } else {
      setValue({
        minWidth: "40",
        maxWidth: "",
        minHeight: "40",
        maxHeight: "",
      });
    }
  }, [value]);

  useEffect(() => {
    if (value) {
      const units = {};
      Object.keys(value).forEach((key) => {
        if (value[key] === "" || !isNaN(value[key])) {
          return (units[key] = "px");
        }

        if (isNaN(value[key])) {
          return (units[key] = value[key].slice(-2));
        }
      });
      setUnits(units);
    } else {
      setUnits({
        minWidth: "px",
        maxWidth: "px",
        minHeight: "px",
        maxHeight: "px",
      });
    }
  }, []);

  const handleUpdate = (v, key) => {
    const value = { ..._value };
    const unit = units[key];
    if (!v) {
      value[key] = "";
      setValue(value);
      return;
    }
    value[key] = v;
    setValue(value);
  };

  const handleUnitChange = (value, key) => {
    const _units = { ...units };
    _units[key] = value;
    setUnits(_units);
  };

  const handleSave = () => {
    const value = {};
    Object.keys(_value).forEach((key) => {
      if (!_value[key]) {
        value[key] = "";
        return;
      }
      value[key] = _value[key] + units[key];
    });
    onChange(value);
  };
  return (
    <div
      style={{ display: "flex", alignItems: "center", flexDirection: "column" }}
    >
      <div className={styles.sizeContainer}>
        <div className={styles.rangeTitle}>Min Height</div>
        <div className={styles.sizeInput}>
          <input
            value={_value.minHeight}
            onChange={(e) => handleUpdate(e.target.value, "minHeight")}
            onBlur={handleSave}
            type={"number"}
            className="input"
          />
          <select
            onChange={(e) => handleUnitChange(e.target.value, "minHeight")}
            value={units.minHeight}
          >
            <option value={"px"}>px</option>
            <option value={"%"}>%</option>
            <option value={"vw"}>vw</option>
            <option value={"vh"}>vh</option>
          </select>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <div className={styles.sizeContainer}>
          <div className={styles.rangeTitle}>Min Width</div>
          <div className={styles.sizeInput}>
            <input
              value={_value.minWidth}
              onChange={(e) => handleUpdate(e.target.value, "minWidth")}
              onBlur={handleSave}
              className="input"
              type={"number"}
            />
            <select
              onChange={(e) => handleUnitChange(e.target.value, "minWidth")}
              value={units.minWidth}
            >
              <option value={"px"}>px</option>
              <option value={"%"}>%</option>
              <option value={"vw"}>vw</option>
              <option value={"vh"}>vh</option>
            </select>
          </div>
        </div>
        <div className={styles.sizeContainer}>
          <div className={styles.rangeTitle}>Max Width</div>
          <div className={styles.sizeInput}>
            <input
              value={_value.maxWidth}
              onChange={(e) => handleUpdate(e.target.value, "maxWidth")}
              onBlur={handleSave}
              className="input"
              type={"number"}
            />
            <select
              onChange={(e) => handleUnitChange(e.target.value, "maxWidth")}
              value={units.maxWidth}
            >
              <option value={"px"}>px</option>
              <option value={"%"}>%</option>
              <option value={"vw"}>vw</option>
              <option value={"vh"}>vh</option>
            </select>
          </div>
        </div>
      </div>
      <div className={styles.sizeContainer}>
        <div className={styles.rangeTitle}>Max Height</div>
        <div className={styles.sizeInput}>
          <input
            value={_value.maxHeight}
            onChange={(e) => handleUpdate(e.target.value, "maxHeight")}
            onBlur={handleSave}
            className="input"
            type={"number"}
          />
          <select
            onChange={(e) => handleUnitChange(e.target.value, "maxHeight")}
            value={units.maxHeight}
          >
            <option value={"px"}>px</option>
            <option value={"%"}>%</option>
            <option value={"vw"}>vw</option>
            <option value={"vh"}>vh</option>
          </select>
        </div>
      </div>
    </div>
  );
}
